(function () {
  'use strict';

  // ── Toggle: See All / See Less ──────────────────────────────
  function initToggle(section) {
    var sectionId = section.getAttribute('data-section-id');

    var toggleBtn = section.querySelector(
      '.cart-preview__toggle-btn[data-section-id="' + sectionId + '"]'
    );
    if (!toggleBtn) return;

    var wrap = section.querySelector('#cart-preview-items-' + sectionId);
    if (!wrap) return;

    var announcement = wrap.querySelector('[data-cart-preview-announcement]');

    toggleBtn.addEventListener('click', function () {
      var expanded = this.getAttribute('aria-expanded') === 'true';
      var next = !expanded;
      this.setAttribute('aria-expanded', String(next));
      wrap.classList.toggle('is-expanded', next);

      // Sync aria-hidden on overflow items
      var overflowItems = wrap.querySelectorAll(
        '.cart-preview__item--overflow-mobile, .cart-preview__item--overflow-desktop'
      );
      overflowItems.forEach(function (item) {
        item.setAttribute('aria-hidden', next ? 'false' : 'true');
      });

      // Announce expand/collapse to screen readers via live region
      if (announcement) {
        var hiddenCount = overflowItems.length;
        announcement.textContent = next
          ? this.querySelector('.cart-preview__toggle-label-see-less').textContent
          : hiddenCount + ' ' + (hiddenCount === 1 ? 'item' : 'items') + ' hidden. ' +
            this.querySelector('.cart-preview__toggle-label-see-all').textContent + ' to expand.';
      }
    });
  }

  function initCartPreview(section) {
    initToggle(section);
    initEditCartLinks(section);
  }

  // ── Edit Cart → open cart drawer ───────────────────────────
  function initEditCartLinks(section) {
    section.querySelectorAll('[data-open-cart-drawer]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var drawer = document.querySelector('cart-drawer');
        if (drawer) drawer.open(btn);
      });
    });
  }

  // ── Section Rendering API re-render ────────────────────────
  // Triggered by cart-preview:updated, dispatched from cart-drawer.js
  // and cart.js whenever the cart changes (add, remove, quantity update).
  var renderInFlight = false;

  function rerenderCartPreview() {
    // Debounce: if a render is already in flight, skip
    if (renderInFlight) return;
    renderInFlight = true;

    var sections = document.querySelectorAll('[data-section-type="cart-preview"]');
    if (!sections.length) {
      renderInFlight = false;
      return;
    }

    // Collect section ids to request (supports multiple instances, though usually one)
    var sectionIds = [];
    sections.forEach(function (el) {
      sectionIds.push(el.getAttribute('data-section-id'));
    });

    fetch('/?sections=' + sectionIds.join(','))
      .then(function (response) {
        if (!response.ok) throw new Error('Section render fetch failed: ' + response.status);
        return response.json();
      })
      .then(function (data) {
        sections.forEach(function (section) {
          var sectionId = section.getAttribute('data-section-id');
          var freshHTML = data[sectionId];
          if (!freshHTML) return;

          var parsed = new DOMParser().parseFromString(freshHTML, 'text/html');
          var freshSection = parsed.querySelector('.shopify-section');
          if (!freshSection) return;

          // Replace the entire shopify-section wrapper, not just its contents,
          // so we don't end up with a nested .cart-preview inside the existing one
          var shopifySection = section.closest('.shopify-section');
          if (!shopifySection) return;
          shopifySection.replaceWith(freshSection);

          // Find the new cart-preview element in the freshly inserted markup
          var newSection = freshSection.querySelector('[data-section-type="cart-preview"]');
          if (!newSection) return;

          initToggle(newSection);
          initEditCartLinks(newSection);

          document.dispatchEvent(new CustomEvent('cart-preview:rendered'));
        });
      })
      .catch(function (err) {
        console.error('[cart-preview] re-render failed:', err);
      })
      .finally(function () {
        renderInFlight = false;
      });
  }

  // ── Boot ────────────────────────────────────────────────────
  function init() {
    document.querySelectorAll('[data-section-type="cart-preview"]').forEach(initCartPreview);

    // Listen for the event dispatched by cart-drawer.js and cart.js
    document.addEventListener('cart-preview:updated', rerenderCartPreview);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();